import { render, staticRenderFns } from "./ExchangeRelease.vue?vue&type=template&id=924ffa54&scoped=true&"
import script from "./ExchangeRelease.vue?vue&type=script&lang=ts&"
export * from "./ExchangeRelease.vue?vue&type=script&lang=ts&"
import style0 from "./ExchangeRelease.vue?vue&type=style&index=0&id=924ffa54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "924ffa54",
  null
  
)

export default component.exports